import { Component, OnInit, Input } from '@angular/core';
import { CampaniasService } from '../services/campanias.service';
import { SpinnerService } from '../services/spinner.service';
import { Campaign } from '../../app/models/campaign.model';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.scss']
})
export class CampaignComponent implements OnInit {

  @Input() home: boolean = false;
  public campaignList: Array<Campaign[]>;
  public documentIcon = 'http://fundacion.bcr.com.ar/imagenes/documento/documento.png';
  public documentDescription = 'Mas información sobre la campaña'

  constructor(
    private campaignService: CampaniasService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.getAll();
    console.log(this.home);

  }

  public getAll() {
    this.spinnerService.updatedState(true);
    this.campaignService.getAll()
      .subscribe(
        (data: any) => {
          this.campaignList = new Array<Campaign[]>();
          this.campaignList = data;
          this.getEnabled();
          this.isHome();
          this.spinnerService.updatedState(false);
        },
        (err) => {
          this.spinnerService.updatedState(false);
        }
      );
  }

  public getEnabled() {
    this.campaignList = this.campaignList.filter(
      (campaign: any) => { return campaign.Habilitada == true; }
    )
  }

  public isHome() {
    if(this.home && this.campaignList.length > 0) {
      this.campaignList = new Array(this.campaignList[0]);
    }
  }

  public getDateFomatCreated(value: string) {
    return value.substring(0, 10);
  }

}
